import { Collection } from 'modules/core/lib/mobx-rest'

import JobLevelSalaryRange from 'modules/job_catalog/store/models/JobLevelSalaryRange'

class JobLevelSalaryRanges extends Collection<JobLevelSalaryRange> {
  get cacheKey(): string {
    return 'jobLevelSalaryRanges'
  }

  model() {
    return JobLevelSalaryRange
  }

  fromJobLevels(levelIds: string[]): JobLevelSalaryRange[] {
    return this.filter((x) => levelIds.includes(x.attributes.level_id))
  }

  fromJobLevel(levelId: string): JobLevelSalaryRange | undefined {
    return this.find({ level_id: levelId })
  }

  fromJobLevelLegalEntity(legalEntityId: string, levelId: string): JobLevelSalaryRange | undefined {
    return this.filter(
      (x) =>
        x.attributes.legal_entities_ids.includes(legalEntityId) && x.attributes.level_id === levelId
    )[0]
  }
}

const singleton = new JobLevelSalaryRanges()

export default singleton
